function VaultLogo(props) {
  return (
    <svg
      width={548}
      height={548}
      viewBox='0 0 548 548'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M527.722 427.137c4.262-4.262 4.262-11.173 0-15.435-4.262-4.262-11.172-4.262-15.434 0l15.434 15.435zM26.316 133.786l-7.81-7.624 7.81 7.624zM398.17 519.04H45.841v21.828h352.328V519.04zm-368.7-16.371V152.845H7.643v349.824H29.47zm482.819-90.967L409.745 514.245l15.434 15.435 102.543-102.543-15.434-15.435zM34.126 141.409L136.9 36.129 121.28 20.88 18.506 126.162l15.62 15.247zM45.84 519.04c-9.042 0-16.371-7.329-16.371-16.371H7.642c0 21.097 17.102 38.199 38.199 38.199V519.04zm352.328 21.828a38.195 38.195 0 0027.01-11.188l-15.434-15.435a16.375 16.375 0 01-11.576 4.795v21.828zm-368.7-388.023c0-4.273 1.672-8.378 4.657-11.436l-15.62-15.247a38.197 38.197 0 00-10.864 26.683H29.47z'
        fill='#000'
      />
      <path
        d='M150.986 424.812h352.521c15.069 0 27.285-12.216 27.285-27.285V45.007c0-15.07-12.216-27.285-27.285-27.285H150.986c-15.069 0-27.285 12.215-27.285 27.285v352.52c0 15.069 12.216 27.285 27.285 27.285z'
        fill='#fff'
      />
      <path
        d='M503.507 413.898H150.986v21.828h352.521v-21.828zm-368.892-16.371V45.007h-21.828v352.52h21.828zm385.263-352.52v352.52h21.828V45.007h-21.828zM150.986 28.636h352.521V6.808H150.986v21.828zm390.72 16.37c0-21.096-17.103-38.198-38.199-38.198v21.828c9.041 0 16.371 7.33 16.371 16.37h21.828zm-390.72 368.892c-9.041 0-16.371-7.329-16.371-16.371h-21.828c0 21.097 17.102 38.199 38.199 38.199v-21.828zm352.521 21.828c21.096 0 38.199-17.102 38.199-38.199h-21.828c0 9.042-7.33 16.371-16.371 16.371v21.828zM134.615 45.006c0-9.04 7.33-16.37 16.371-16.37V6.808c-21.097 0-38.199 17.102-38.199 38.199h21.828z'
        fill='#000'
      />
      <path
        d='M121.003 41.986L17.208 143.085c.45 101.548 1.348 312.462 1.348 343.735 0 31.274 16.176 41.788 24.264 43.136H409.47l99.75-103.795H160.094c-31.273 0-39.091-20.669-39.091-31.003V41.986z'
        fill='#000'
        stroke='#000'
        strokeWidth={2.69596}
      />
      <path
        d='M453.755 136.722a10.547 10.547 0 00-10.55-10.55c-58.688 0-108.971-39.499-109.465-39.89a10.555 10.555 0 00-13.178 0c-.497.401-50.546 39.89-109.454 39.89a10.55 10.55 0 00-10.549 10.55v94.949a126.596 126.596 0 10253.194 0l.002-94.949zm-21.1 94.949c0 27.98-11.115 54.814-30.9 74.596a105.49 105.49 0 01-149.193 0 105.487 105.487 0 01-30.901-74.596v-84.755a220.52 220.52 0 00105.498-39.298 220.527 220.527 0 00105.499 39.298l-.003 84.755z'
        fill='#000'
        stroke='#fff'
        strokeWidth={2.56792}
      />
      <path
        d='M318.244 253.658a9.098 9.098 0 0018.194 0v-7.185a11.833 11.833 0 00-.994-16.178 11.825 11.825 0 00-19.91 7.893 11.835 11.835 0 002.71 8.285v7.185z'
        fill='#000'
      />
      <path
        d='M365.804 203.641H361v-13.347a33.68 33.68 0 00-67.357 0v13.347h-4.804a12.32 12.32 0 00-12.321 12.321v57.908a12.32 12.32 0 0012.321 12.322h76.968a12.321 12.321 0 0012.322-12.322v-57.785a12.322 12.322 0 00-12.322-12.444h-.003zm-57.169-13.347a18.695 18.695 0 019.577-15.453 18.695 18.695 0 0118.18 0 18.701 18.701 0 019.577 15.453v13.347h-37.333l-.001-13.347zm54.622 81.031h-71.871v-52.692h71.871v52.692z'
        fill='#000'
      />
    </svg>
  );
}

export default VaultLogo;
